import React from 'react';
import { ArrowRight } from 'lucide-react';
import DecorativeImage from '../DecorativeImage';

const LPWhyChooseUsSection = ({ onOpenModal }) => (
  <section className="py-24 bg-white" data-testid="lp-why-choose-us-section">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">

        {/* Left — Content */}
        <div data-testid="why-choose-content">
          <p className="eyebrow mb-4">Why Choose Us</p>
          <h2 className="font-display text-4xl md:text-5xl font-bold text-[#111C16] tracking-tighter leading-tight mb-6">
            Leading Trademark Registration Partner
          </h2>
          <p className="font-body text-base text-[#4A5D53] leading-relaxed mb-4">
            Your brand identity deserves professional legal protection. We provide comprehensive USPTO trademark registration services that give you exclusive nationwide rights to your business name, logo, and slogan.
          </p>
          <p className="font-body text-base text-[#4A5D53] leading-relaxed mb-8">
            Our licensed IP attorneys have successfully registered <strong className="text-[#111C16]">10,000+ trademarks</strong> with an industry-leading <strong className="text-[#C85A40]">98% approval rate</strong>. From initial search to final registration certificate, we handle everything.
          </p>
          <button
            onClick={() => onOpenModal?.('Why Choose Us - LP')}
            className="bg-[#C85A40] hover:bg-[#A64730] text-white font-body font-medium px-8 py-4 rounded-full transition-colors flex items-center gap-2"
            data-testid="why-choose-cta-button"
          >
            Get Free Consultation
            <ArrowRight className="h-4 w-4" strokeWidth={1.5} />
          </button>
        </div>

        {/* Right — Image */}
        <div data-testid="why-choose-image">
          <DecorativeImage
            src="/assets/img/lp2.webp"
            alt="Modern office interior"
          />
        </div>

      </div>
    </div>
  </section>
);

export default LPWhyChooseUsSection;
